module.exports = __webpack_public_path__ + "img/Blog-Image.1ead6303.png";